import { baseApi } from './baseApi';

export const landingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHome: builder.query({
      query: (params) => ({
        url: '/home',
        params,
      }),
    }),
    getPrivacyPolicy: builder.query({
      query: (params) => ({
        url: '/privacy-policy',
        params,
      }),
    }),
    getTermsConditions: builder.query({
      query: (params) => ({
        url: '/terms-conditions',
        params,
      }),
    }),
    getReturnRefund: builder.query({
      query: (params) => ({
        url: '/return-refund',
        params,
      }),
    }),
    submitContact: builder.mutation({
      query: (data) => ({
        url: '/submit-contact',
        method: 'POST',
        body: data,
      }),
    }),
    getSubscriptionPackages: builder.query({
      query: (params) => ({
        url: '/subscription/packages',
        params,
      }),
    }),
    getSubscriptionCards: builder.query({
      query: (params) => ({
        url: '/subscription/cards',
        params,
      }),
    }),
    makeSubscriptionPayment: builder.mutation({
      query: (data) => ({
        url: '/subscription/payment',
        method: 'POST',
        body: data,
      }),
    }),
    deleteSubscriptionCard: builder.mutation({
      query: (data) => ({
        url: '/subscription/delete-card',
        method: 'POST',
        body: data,
      }),
    }),
    getMySubscription: builder.query({
      query: (params) => ({
        url: '/subscription/my-subscription',
        params,
      }),
    }),
    cancelSubscription: builder.mutation({
      query: (data) => ({
        url: '/subscription/cancel-subscription',
        method: 'POST',
        body: data,
      }),
    }),
    purchasePackage: builder.mutation({
      query: (data) => ({
        url: '/purchasePackage',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetHomeQuery,
  useGetPrivacyPolicyQuery,
  useGetTermsConditionsQuery,
  useGetReturnRefundQuery,
  useSubmitContactMutation,
  useGetSubscriptionPackagesQuery,
  useGetSubscriptionCardsQuery,
  useMakeSubscriptionPaymentMutation,
  useDeleteSubscriptionCardMutation,
  useGetMySubscriptionQuery,
  useCancelSubscriptionMutation,
  usePurchasePackageMutation,
} = landingApi;

